/*
* type 点播平台类型 (2：百家云、其余默认保利威；10：私有云/视频直链 → HTML5)
*
* time 上传进度的时间 默认是3秒
*/
import Polyv from './polyv'
import Baijiayun from './baijiayun'
import UrlPlayer from './url'

const initPlayer = function (data = {}, type = 1, time = 3000) {
  const platform = Number(type)
  // 视频链接 / 私有云直链：HTML5 播放，避免保利威播直链报 #0074
  if (platform === 10) {
    return new UrlPlayer(data, time)
  }
  if (platform === 2) {
    return new Baijiayun(data, time)
  }
  return new Polyv(data, time)
}

export default initPlayer
